import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import { Badge, Fab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useWarehouseLabelBuffer } from "../../../../../../contexts/WarehouseLabelBuffer";
import WarehouseLabelQueuePanel from "./WarehouseLabelQueuePanel";

// Rendered globally (mounted via WarehouseQueueFabs.jsx in
// DefaultContainer.js) but only visible once the buffer actually has
// something in it - so it never appears outside warehouse pages under
// normal use, without needing route-matching logic. Positioning is owned
// by WarehouseQueueFabs.jsx, which stacks this alongside the shopping list
// FAB rather than both floating at the same fixed coordinates.
export default function WarehouseLabelQueueFab() {
  const { t } = useTranslation();
  const { count } = useWarehouseLabelBuffer();
  const [open, setOpen] = useState(false);

  if (count === 0) {
    return null;
  }

  return (
    <>
      <Fab color="primary" onClick={() => setOpen(true)} title={t("LabelPrintQueue")}>
        <Badge badgeContent={count} color="error">
          <LocalOfferOutlined />
        </Badge>
      </Fab>
      <WarehouseLabelQueuePanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
